import { Facebook, Instagram } from "lucide-react";
import { Link } from "react-router-dom";
import styles from "./FacultyPage.module.css";

const FacultyPage = () => {
  const nupur = {
    name: "Nupur",
    profilePic: "/assets/imgs/gallery/nupur_profile_photo.jpeg",
    bio: "Passionate educator and visual artist with over 10 years of experience in oil painting and digital illustration.",
    socials: { ig: "#", tw: "#", li: "#" },
    experience: [
      { year: "2020 - Present", role: "Senior Faculty", place: "Art Academy" },
      { year: "2015 - 2020", role: "Visual Artist", place: "Creative Studio" },
    ],
    education: "Master of Fine Arts, Royal College of Art",
    skills: ["Oil Painting", "Curriculum Design", "Art History", "Mentorship"],
  };

  return (
    <div className={styles.pageContainer}>
      <div className={styles.splitLayout}>
        {/* LEFT COLUMN: ABOUT SECTION */}
        <section className={styles.aboutSide}>
          <div className={styles.profileCard}>
            <div className={styles.imageWrapper}>
              <img
                src={nupur.profilePic}
                alt="Nupur"
                className={styles.profileImg}
              />
            </div>
            <h2>About Nupur</h2>
            <p className={styles.tagline}>Artist & Educator</p>

            <div className={styles.socialGroup}>
              <Link
                to="https://instagram.com/nupur_ghosh78"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Instagram size={20} className={styles.icon} />
              </Link>
              <Link
                to="https://www.facebook.com/share/187dttcLge/?mibextid=wwXIfr"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Facebook size={20} className={styles.icon} />
              </Link>
            </div>

            <button className={styles.followBtn}>Follow on Social Media</button>
          </div>
        </section>

        {/* RIGHT COLUMN: FREEFLOW TEXT */}
        <main className={styles.resumeSide}>
          <div className={styles.freeflowCard}>
            <h1 className={styles.mainTitle}>Nupur's Professional Journey</h1>

            <article className={styles.textContent}>
              <p>
                Nupur is a freelancer, entrepreneur and Art teacher with
                extensive experience in teaching fine art to students in the
                northern part of Va and have online students throughout the east
                course of USA. Nupur designs and make custom jewelry as her
                passion. About myself: I am a passionate learner of Fine
                arts.Nupur started learning art and painting at an early age of
                6 years. Nupur learned from multiple art teachers while in
                India.
              </p>

              <p>
                Nupur conducted classes/ workshops for kids , teen , adults from
                beginner level to advanced level. Nupur learned different art
                medium like oil pastel, water color, charcoal, oil painting,
                acrylic also started exploring other mediums like glass
                painting, dot painting, modeling clay to name a few. As an
                educator, Nupur believes that every student possesses a unique
                creative voice. My curriculum focuses on mastering the
                fundamentals—color theory, perspective, and brushwork—while
                encouraging personal expression. Nupur had the privilege of
                mentoring hundreds of aspiring artists, many of whom have gone
                on to showcase their work in international galleries.
              </p>

              <p>
                So, I do extensive work in Oil and acrylic and also take deep
                interest in Portrait painting using graphite/charcoal as well as
                acrylic and Oil. Nupur believes that knowledge increases when it
                is shared so whatever she learned she always tries to share that
                knowledge with other people who are passionate about it. During
                pandemic, she started learning advanced Portrait painting in
                different mediums and hoping to improve her portrait skills more
                in the future. Nupur would like to continue my career in
                teaching art to whoever is eager to know about this subject.
              </p>

              <div className={styles.signature}>— Nupur</div>
            </article>
          </div>
        </main>
      </div>
    </div>
  );
};

export default FacultyPage;
